// components/ui/textarea.js
import React from "react";
import { useConfig } from '../../context/ConfigContext';

export function Textarea({ className, ...props }) {
  const { config } = useConfig();
  
  return (
    <textarea
      className={`w-full min-h-20 rounded-md p-2 focus:outline-none ${className}`}
      style={{ 
        borderColor: `${config.colors.textSecondary}50`,
        borderWidth: '1px',
        borderStyle: 'solid'
      }}
      onFocus={(e) => {
        e.target.style.borderColor = 'transparent';
        e.target.style.boxShadow = `0 0 0 2px ${config.colors.primary}, 0 0 0 2px ${config.colors.primary}30`;
      }}
      onBlur={(e) => {
        e.target.style.borderColor = `${config.colors.textSecondary}50`;
        e.target.style.boxShadow = 'none';
      }}
      {...props}
    />
  );
}



// // components/ui/textarea.js
// import React from "react";

// export function Textarea({ className, ...props }) {
//   return (
//     <textarea
//       className={`w-full min-h-20 rounded-md border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${className}`}
//       {...props}
//     />
//   );
// }